import MentionCard from "./mention-card";

export default MentionCard;